import React from 'react';

const ReviewData = ({reviewId, reviewData}) => {
  if(reviewData){
    const dataDisplay = reviewData.map(dataItem =>
      <div key={`${reviewId}-${dataItem.name}`} className="review-data-row">
        <span className="key">{dataItem.name}</span>
        <span className="value">{dataItem.value}</span>
      </div>
    );
    return (
      <div className="review-data">
        {dataDisplay}
      </div>
    );
  }else {
    return (<span />);
  }
};

export default ReviewData;
